export default __webpack_public_path__ + "static/media/redArrow.78cf795f.svg";